function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgErrorLarge = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 70 70"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M35.11 0a35 35 0 1 0 35 35 35 35 0 0 0-35-35m0 68a33 33 0 1 1 33-33 33 33 0 0 1-33 33",
  style: {
    fill: "#1d1d1b",
    fillRule: "evenodd"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M33.61 18.22h3v25h-3z",
  style: {
    fill: "#1d1d1b"
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 35.11,
  cy: 50.03,
  r: 2.5,
  style: {
    fill: "#1d1d1b"
  }
}));
export default SvgErrorLarge;